import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { environment } from '../../../environments/environment';
import { AttractImageVO, LFAttractScreensVO, AttractImage, AttractScreenImageVO, LFImageLibraryGroupingVO, SaveAttractScreenVO, ApplyAttractScreen } from './attract-screen.model';

@Injectable({
  providedIn: 'root'
})
export class AttractScreenService {

  constructor(private httpClient: HttpClient,
    private httpHeaderService: HttpHeadersService) { }

  async getAttractScreens(facilityIds: string, consoleType: string) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    let result = await this.httpClient.post(`${environment.servicePath}/attract_screen/get_attract_screens/`, 
      { facilityIds : facilityIds, consoleType: consoleType}, { headers })
      .toPromise();
    return this.processAttractScreenData(result);
  }

  async deleteAttractScreen(setId: string | any, console: string) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.delete(`${environment.servicePath}/attract_screen/delete_attract_screen/${setId}/${console}`, 
      { headers })
      .toPromise();
  }

  async getImageLibrary(consoleType: string): Promise<LFImageLibraryGroupingVO> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(`${environment.servicePath}/attract_screen/get_image_library?consoleType=${consoleType}&temp=${Math.random()}`, 
      { headers })
      .toPromise();
  }

  async uploadImage(formData: any) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeaderWithoutContentType();
    return await this.httpClient.post(`${environment.servicePath}/attract_screen/upload_image/`, 
      formData, { headers })
      .toPromise();
  }

  async saveImage(data: AttractScreenImageVO) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return await this.httpClient.post(`${environment.servicePath}/attract_screen/save_image_file/`, 
      data, { headers })
      .toPromise();
  }

  async deleteImage(imageId: string) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return await this.httpClient.delete(`${environment.servicePath}/attract_screen/delete_image/?imageId=${imageId}`, 
      { headers })
      .toPromise();
  }
  
  async getImageInfo(imageId: string) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(`${environment.servicePath}/attract_screen/get_attract_image/${imageId}`, 
      { headers })
      .toPromise();
  }
  
  async copyImage(imageId: string, from: string, to: string) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(`${environment.servicePath}/attract_screen/copy_attract_image/${imageId}/${from}/${to}`, 
      '', { headers })
      .toPromise();
  }
  
  async saveEditAttractScreen(attractScreen: SaveAttractScreenVO) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(`${environment.servicePath}/attract_screen/save_attract_screens`, 
      attractScreen, { headers })
      .toPromise();
  }
  
  async getAttractScreenEquipmentList(data: any) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(`${environment.servicePath}/attract_screen/attract_screen_equip_list`, 
      data, { headers })
      .toPromise();
  }

  async applyAttractScreen(attractScreen: ApplyAttractScreen) {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(`${environment.servicePath}/attract_screen/apply_screen`, 
    attractScreen, { headers })
      .toPromise();
  }

  getConsoleImage(consoleType: string, size: string = 'md') {
    let imgSize = '342x249';
    switch(size) {
      case 'md':
        imgSize = '342x249';
        break;
      case 'lg':
        imgSize = '731x532';
        break;
    }
    consoleType = consoleType || 'disconver_se'; // default
    let consoleImgName = `Console_${consoleType.toUpperCase()}_${imgSize}.png`
    return `${environment.cloudBasePath}/Products/${consoleImgName}`;
  }

  private processAttractScreenData(data: any): LFAttractScreensVO {
    if(!data) return data;
    return {
      has307Software: data.has307Software === 'true',
      attractSets: data.attractSets?.map((s: any) => {
        let images = this.getAttractImages(s);
        return {
          activityId: Number(s.activityId),
          backgroundColor: s.backgroundColor,
          consoleType: s.consoleType,
          hasScrolling: s.hasScrolling === 'true',
          inUse: s.inUse === 'true',
          message: s.message ? decodeURIComponent(s.message): '',
          messageFontColor: s.messageFontColor,
          name: s.name,
          publishedAt: s.publishedAt,
          setId: s.setId,
          updatedAt: s.updatedAt,
          userId: s.userId,
          images: images,
          hasImage: images?.some(i => !!i.name)
        }
      })
    };
  }

  private getAttractImages(attractSet: any): AttractImageVO[] {
    let images: AttractImageVO[] = [];
    if(attractSet.firstImage) {
      images.push({
        name: attractSet.firstImage,
        height: Number(attractSet.firstImageSourceHeight),
        width: Number(attractSet.firstImageSourceWidth),
        url: attractSet.consoleType === "hal"? attractSet.firstImageSourceImageUrl: attractSet.firstImageThumbnailUrl,
        backgroundColor: attractSet.firstImageBackgroundColor
      });
    } else {
      images.push({});
    }
    if(attractSet.secondImage) {
      images.push({
        name: attractSet.secondImage,
        height: Number(attractSet.secondImageSourceHeight),
        width: Number(attractSet.secondImageSourceWidth),
        url: attractSet.consoleType === "hal"? attractSet.secondImageSourceImageUrl: attractSet.secondImageThumbnailUrl,
        backgroundColor: attractSet.secondImageBackgroundColor
      });
    } else {
      images.push({});
    }
    if(attractSet.thirdImage) {
      images.push({
        name: attractSet.thirdImage,
        height: Number(attractSet.thirdImageSourceHeight),
        width: Number(attractSet.thirdImageSourceWidth),
        url: attractSet.consoleType === "hal"? attractSet.thirdImageSourceImageUrl: attractSet.thirdImageThumbnailUrl,
        backgroundColor: attractSet.thirdImageBackgroundColor
      });
    } else {
      images.push({});
    }
    if(attractSet.fourthImage) {
      images.push({
        name: attractSet.fourthImage,
        height: Number(attractSet.fourthImageSourceHeight),
        width: Number(attractSet.fourthImageSourceWidth),
        url: attractSet.consoleType === "hal"? attractSet.fourthImageSourceImageUrl: attractSet.fourthImageThumbnailUrl,        
        backgroundColor: attractSet.fourthImageBackgroundColor
      });
    } else {
      images.push({});
    }
    if(attractSet.fifthImage) {
      images.push({
        name: attractSet.fifthImage,
        height: Number(attractSet.fifthImageSourceHeight),
        width: Number(attractSet.fifthImageSourceWidth),
        url:  attractSet.consoleType === "hal"? attractSet.fifthImageSourceImageUrl: attractSet.fifthImageThumbnailUrl,        
        backgroundColor: attractSet.fifthImageBackgroundColor
      });
    } else {
      images.push({});
    }
    return images;
  }

}
